/**
 * How long a captured leg lasted, as a compact label for a list row.
 *
 * Answered calls are measured from the answer, not from the invite: a leg that
 * rang for 20s and talked for 2s is a 2s call, and reading it as 22s hides the
 * thing worth noticing.
 */
export const formatCallDuration = (
  startTime: string | null | undefined,
  endTime: string | null | undefined
): string | null => {
  if (!startTime || !endTime) {
    return null;
  }

  const elapsedMs =
    new Date(endTime).getTime() - new Date(startTime).getTime();

  if (Number.isNaN(elapsedMs) || elapsedMs < 0) {
    return null;
  }

  const totalSeconds = Math.round(elapsedMs / 1000);

  if (totalSeconds < 60) {
    return `${totalSeconds}s`;
  }

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes < 60) {
    return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
  }

  const hours = Math.floor(minutes / 60);

  return `${hours}h ${String(minutes % 60).padStart(2, '0')}m`;
};
